import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faMotorcycle } from '@fortawesome/free-solid-svg-icons';

export const AdminTopDriversList = ({ topDrivers = [], onNavigate }) => {
  return (
    <div
      className="p-4 rounded-4 shadow-lg mb-4"
      style={{
        backgroundColor: 'rgba(20, 20, 20, 0.95)',
        border: '1px solid rgba(14, 171, 176, 0.25)'
      }}
    >
      <div className="d-flex align-items-center justify-content-between mb-3 pb-2 border-bottom border-secondary border-opacity-25">
        <div>
          <h5 className="text-white fw-bold mb-0">Conductores Líderes (Algoritmo Wilson)</h5>
          <span className="text-white-50 small">Top 5 evaluados por confianza y volumen de viajes</span>
        </div>
        <button
          className="btn btn-link text-decoration-none p-0 small fw-bold"
          style={{ color: 'var(--bry-accent, #0EABB0)' }}
          onClick={() => onNavigate?.('/admin/conductores')}
        >
          Ver Conductores
        </button>
      </div>

      <div className="table-responsive">
        <table className="table table-dark table-hover align-middle mb-0" style={{ backgroundColor: 'transparent' }}>
          <thead>
            <tr className="text-white-50 small text-uppercase">
              <th>Posición</th>
              <th>Conductor</th>
              <th>Vehículo</th>
              <th>Saldo Billetera</th>
              <th>Reputación (Wilson)</th>
              <th>Estado</th>
            </tr>
          </thead>
          <tbody>
            {topDrivers.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center py-3 text-white-50 small">
                  No hay datos suficientes de conductores.
                </td>
              </tr>
            ) : (
              topDrivers.map((driver, idx) => {
                const driverName = driver.profile_data?.name || driver.name || driver.full_name || 'Conductor';
                const avatarUrl = driver.profile_data?.avatar_url || driver.avatar_url;
                const vehicleLabel = driver.profile_data?.vehicle_type || driver.vehicle_model || driver.vehicle_type || 'Mototaxi';
                const walletBal = Number(driver.profile_data?.wallet_balance ?? driver.wallet_balance ?? 0);
                const wilsonScore = Number(driver.wilson_score_rating ?? driver.rating ?? 0);
                const totalReviews = Number(driver.total_reviews ?? 0);
                const avgRating = Number(driver.average_rating ?? 0);

                return (
                  <tr key={driver.driver_uid || driver.id || idx}>
                    <td className="fw-bold" style={{ color: 'var(--bry-accent, #0EABB0)' }}>
                      #{idx + 1}
                    </td>
                    <td>
                      <div className="d-flex align-items-center gap-2">
                        {avatarUrl ? (
                          <img
                            src={avatarUrl}
                            alt={driverName}
                            className="rounded-circle object-fit-cover"
                            style={{ width: '36px', height: '36px', border: '1.5px solid var(--bry-accent, #0EABB0)' }}
                          />
                        ) : (
                          <div
                            className="rounded-circle d-flex align-items-center justify-content-center"
                            style={{ width: '36px', height: '36px', backgroundColor: 'rgba(14, 171, 176, 0.15)', color: 'var(--bry-accent, #0EABB0)' }}
                          >
                            <FontAwesomeIcon icon={faMotorcycle} />
                          </div>
                        )}
                        <span className="fw-semibold text-white">{driverName}</span>
                      </div>
                    </td>
                    <td className="text-white-50 small text-capitalize">{vehicleLabel}</td>
                    <td>
                      <span
                        className="badge rounded-pill px-2 py-1 fw-bold"
                        style={{
                          backgroundColor: walletBal > 0 ? 'rgba(34, 197, 94, 0.18)' : 'rgba(255, 255, 255, 0.08)',
                          color: walletBal > 0 ? '#4ade80' : '#9ca3af',
                          border: walletBal > 0 ? '1px solid rgba(74, 222, 128, 0.4)' : '1px solid rgba(255, 255, 255, 0.15)'
                        }}
                      >
                        ${walletBal.toFixed(2)} USD
                      </span>
                    </td>
                    <td>
                      <div className="d-flex align-items-center gap-1 text-warning small" title={totalReviews > 0 ? `Promedio simple: ${avgRating.toFixed(1)}★ | Wilson 95%: ${wilsonScore.toFixed(2)}` : 'Sin valoraciones aún'}>
                        <FontAwesomeIcon icon={faStar} />
                        <span className="fw-bold text-white ms-1">
                          {wilsonScore.toFixed(2)}
                        </span>
                        <span className="text-white-50">
                          ({totalReviews} {totalReviews === 1 ? 'voto' : 'votos'})
                        </span>
                      </div>
                    </td>
                    <td>
                      <span className="badge rounded-pill px-2 py-1" style={{ backgroundColor: 'rgba(14, 171, 176, 0.15)', color: 'var(--bry-accent, #0EABB0)', border: '1px solid var(--bry-accent, #0EABB0)' }}>
                        Verificado
                      </span>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminTopDriversList;
